import React, { useEffect } from "react";
import { Header, Button, Card, Container, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { getClaveDobleFactorUsuario } from "./../../../../app/store/actions/transactionalActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import ServicioNoDisponibleMessage from "../../../../app/common/messages/ServicioNoDisponibleMessage";
import UsuarioSinClaveDobleFactorMessage from "../../../../app/common/messages/UsuarioSinClaveDobleFactorMessage";
import { esListaNoVacia } from "../../../../app/util/arrayUtils";

const mapState = (state) => ({
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
  loadingClaveDobleFactorUsuario:
    state.transactionalReducer.loadingClaveDobleFactorUsuario,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  disponibilidadPago: state.pagoReducer.disponibilidadPago,
});

const actions = {
  getClaveDobleFactorUsuario,
  verificarDisponibilidadPago,
};

const AperturarCuentaPage = ({
  currentUser,
  getClaveDobleFactorUsuario,
  claveDobleFactorUsuario,
  loadingClaveDobleFactorUsuario,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  disponibilidadPago,
}) => {
  //useEffect
  useEffect(() => {
    if (currentUser?.username) {
      getClaveDobleFactorUsuario();
    }
  }, [getClaveDobleFactorUsuario, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      verificarDisponibilidadPago();
    }
  }, [verificarDisponibilidadPago, currentUser]);

  //loadings
  if (loadingClaveDobleFactorUsuario || !claveDobleFactorUsuario)
    return <LoadingComponent content="Cargando información..." />;

  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;

  return (
    <Container className="containerPrincipal" textAlign="center">
      <Header
        as="h1"
        content="Apertura tu cuenta"
        color="blue"
        textAlign="center"
      />
      <Header
        as="h3"
        content="Selecciona el tipo de cuenta:"
        color="blue"
        textAlign="center"
      />
      <br />
      <Card.Group centered>
        <Card>
          <Card.Content>
            <Header icon>
              <Image src="/assets/icons/ahorro.svg" size="big" />
            </Header>
            <Card.Meta>
              <span className="date">Sin preocupaciones, ahorras más.</span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div className="ui one buttons center">
              <Button
                as={Link}
                to="/aperturar-cuenta-ahorros"
                basic
                color="blue"
                content="Cuenta de Ahorros"
                disabled={
                  !esListaNoVacia(claveDobleFactorUsuario.lista) ||
                  !disponibilidadPago
                }
              />
            </div>
          </Card.Content>
        </Card>
        <Card>
          <Card.Content>
            <Header icon>
              <Image src="/assets/icons/prestamo.svg" size="medium" />
            </Header>
            <Card.Meta>
              <span className="date">Tu dinero llegará más alto.</span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div className="ui one buttons">
              <Button
                as={Link}
                to="/aperturar-cuenta-dpf"
                basic
                color="blue"
                content="Depósito a Plazo Fijo"
                disabled={
                  !esListaNoVacia(claveDobleFactorUsuario.lista) ||
                  !disponibilidadPago
                }
              />
            </div>
          </Card.Content>
        </Card>
      </Card.Group>
      <br />
      {!esListaNoVacia(claveDobleFactorUsuario.lista) && (
        <UsuarioSinClaveDobleFactorMessage />
      )}
      {!disponibilidadPago && <ServicioNoDisponibleMessage />}
    </Container>
  );
};
AperturarCuentaPage.propTypes = {
  getClaveDobleFactorUsuario: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  claveDobleFactorUsuario: PropTypes.object,
  loadingClaveDobleFactorUsuario: PropTypes.bool.isRequired,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
};

export default connect(mapState, actions)(AperturarCuentaPage);
